import React, { useEffect } from 'react';
import { Icon } from './Icons';
import type { Priority } from '../types';

export function PriorityBadge({ priority = 'Normal' }: { priority?: Priority }) {
  const value = String(priority || 'Normal').toLowerCase();
  return <span className={`priority-badge priority-${value}`}>{priority}</span>;
}

export function GlassCard({ children, className = '', onClick }: { children: React.ReactNode; className?: string; onClick?: () => void }) {
  return <section className={`glass-card ${className}`} onClick={onClick}>{children}</section>;
}

export function EmptyState({ title, detail }: { title: string; detail?: string }) {
  return <div className="empty-state"><div className="empty-orb"/><strong>{title}</strong>{detail && <span>{detail}</span>}</div>;
}

export function Sheet({ open, title, children, onClose, large = false }: { open: boolean; title: string; children: React.ReactNode; onClose: () => void; large?: boolean }) {
  useEffect(() => {
    if (!open) return;
    document.documentElement.classList.add('sheet-open');
    return () => document.documentElement.classList.remove('sheet-open');
  }, [open]);

  if (!open) return null;
  return <div className="sheet-backdrop" role="presentation" onMouseDown={event => { if (event.target === event.currentTarget) onClose(); }}>
    <section className={`bottom-sheet ${large ? 'sheet-large' : ''}`} role="dialog" aria-modal="true" aria-label={title}>
      <div className="sheet-handle"/>
      <header className="sheet-header"><h2>{title}</h2><button className="icon-button sheet-close-button" onClick={onClose} aria-label="Close"><Icon name="close"/></button></header>
      <div className="sheet-content">{children}</div>
    </section>
  </div>;
}

export function Segmented<T extends string>({ value, options, onChange }: { value: T; options: Array<{ value: T; label: string }>; onChange: (value: T) => void }) {
  return <div className="segmented">{options.map(option => <button key={option.value} className={value === option.value ? 'active' : ''} onClick={() => onChange(option.value)}>{option.label}</button>)}</div>;
}

export function Toggle({ checked, onChange, label, detail }: { checked: boolean; onChange: (value: boolean) => void; label: string; detail?: string }) {
  return <label className="toggle-row"><span><strong>{label}</strong>{detail && <small>{detail}</small>}</span><input type="checkbox" checked={checked} onChange={event => onChange(event.target.checked)}/><i/></label>;
}
